<template>
  <!-- 基本信息 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">商家和类目</div>
    </div>
    <div class="information_content">
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          商家
        </div>
        <div class="input_el input_span">
          <div class="newipt" style="display: flex">
            <el-select
              v-model="formData.shop"
              class="width67"
              placeholder="请选择"
              value-key="id"
              :disabled="onlineEdit || system < 5 || isChakan"
              @change="onChangeByShop">
              <el-option
                v-for="item in shopList"
                :key="item.merchantId"
                :label="item.merchantName"
                :value="item.merchantId"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          父SKU
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input
              class="width67"
              v-model="formData.sku"
              @input="inputSkuchange"
              :disabled="
                addStatus == 'edit' || system < 5 || isEditLeimu || isChakan
              "></el-input>
            <el-button
              style="margin-left: 10px"
              type="primary"
              v-if="addStatus != 'edit' && !isEditLeimu && !isChakan"
              :disabled="system < 5"
              @click="createSku">
              生成编号
            </el-button>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          标题
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input
              type="text"
              class="width85"
              v-model="formData.name"
              maxlength="500"
              show-word-limit
              :disabled="system < 5 || isChakan"></el-input>
            <el-tooltip
              placement="right-start"
              effect="light"
              :open-delay="300"
              v-if="system == 5 && !isChakan">
              <template slot="content">首字母大写</template>
              <el-button
                style="background: rgb(245, 245, 245); color: #b7b4b4"
                type="primary"
                @click="capitalizeFirstLetter">
                A a
              </el-button>
            </el-tooltip>
          </div>
          <div style="margin-top: 5px">
            使用中文或英文，推荐格式: 类目+品牌（如有品牌）+名称+变体属性，标题过长或重复单词可能导致审核失败
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          平台分类
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input
              class="width67"
              v-model="formData.categoryName"
              maxlength="20"
              disabled></el-input>
            <el-button
              style="margin-left: 10px"
              type="primary"
              @click="openCategoryDialog"
              v-if="!onlineEdit && !isChakan"
              :disabled="system < 5 || isChakan">
              选择类目
            </el-button>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">文字描述</div>
        <div class="input_el input_span">
          <el-input type="textarea" v-model="formData.desc"></el-input>
        </div>
      </div>
    </div>

    <el-dialog
      title="分类选择"
      :visible.sync="categoryShow"
      append-to-body
      width="1300px"
      top="10vh">
      <div style="display: flex; width: 100%">
        <el-input
          v-model="categorySearchText"
          placeholder="搜索分类名称"
          style="margin-right: 20px"></el-input>
        <el-button type="primary" @click="fetchCategoryByName">搜 索</el-button>
        <el-button type="primary" @click="resetCategorySearch">重 置</el-button>
      </div>
      <template v-if="!categorySearch">
        <div
          style="
            display: flex;
            align-items: center;
            height: 32px;
            background: rgba(255, 244, 240, 1);
            font-size: 14px;
            border: 1px solid indianred;
            color: indianred;
            margin-top: 10px;
            padding-left: 10px;
          ">
          <span>当前所选类目是：{{ categorySelectFullName }}</span>
        </div>
        <el-cascader-panel
          ref="CascaderPanelRef"
          style="height: 500px"
          :options="categoryList"
          :props="categoryProps"
          @change="onCascaderPanelChange"
          @expand-change="onCascaderPanelExpandChange"></el-cascader-panel>
      </template>
      <div class="search_box2" v-else>
        <div style="width: 100%">
          <div class="leimu_box2">
            <div
              :class="{
                select_leimu: item.categoryId === formData.categoryId
              }"
              class="leimu_item"
              v-for="(item, index) in categorySearchList"
              :key="index"
              @click="confirmCategorySearch(item)">
              <div class="leimu_item_desc" v-html="item.fullLabel"></div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" style="margin-top: 60px">
        <el-button @click="categoryShow = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!categoryIsConfirm"
          @click="confirmCategory">
          选 择
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api'
export default {
  name: 'baseInfoComp',
  props: {
    score: {
      type: Array,
      default() {
        return [0, 0, 0, 0]
      }
    }
  },
  data() {
    return {
      roleInfo: null,
      // 商家List
      shopList: [],
      // 类目
      categoryShow: false,
      categoryList: [],
      categoryProps: {
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const id = node.root ? 0 : node.value.categoryId
          const list = await this.fetchNextCategory(id)
          resolve(list)
        }
      },
      categorySelectFullName: '',
      categorySearch: false,
      categorySearchText: '',
      categorySearchList: [],
      categoryIsConfirm: false,
      formData: {
        name: '', // 标题
        shop: null, // 店铺信息
        categoryName: '', // 分类名称
        categoryId: '', // 分类id
        sku: '',
        desc: ''
      },
      categoryAttrList: [],

      //在线产品编辑
      onlineEdit: false,
      //是否为查看
      isChakan: false,
      addStatus: 'add', //判断是新增还是编辑
      isEditLeimu: false, //编辑状态修改了类目

      //原始的属性数组
      oldAttributeList: [],
      //上面的属性数组
      topAttributeList: [],
      //变体的属性数组
      bottomAttributeList: []
    }
  },
  computed: {
    system() {
      return this.roleInfo.system
    }
  },
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
    this.fetchNextList()
  },
  methods: {
    // 获取商家
    async fetchNextList() {
      try {
        const payload = {
          sellerType: 3,
          rid: this.roleInfo.rid,
          companyId: this.roleInfo.company_id,
          system: 5
        }
        const url = Baseurl + 'roleController/selectNextAndMerchantInfoByRid'
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.shopList = data.next
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取类目下级
    async fetchNextCategory(id) {
      try {
        const url =
          Baseurl + `/shopeeCategoryController/getCategoryByParentId/${id}`
        const res = await ajaxGet(url)
        const { code, data } = res.data
        if (code === 200) {
          const list = data.map((item) => {
            const label = `${item.originalCategoryName} - ${item.displayCategoryName}`
            return {
              label,
              value: { label, ...item },
              leaf: !item.hasChildren
            }
          })
          return list
        }
        return false
      } catch (error) {
        console.log(error)
      }
    },
    onChangeByShop(e) {
      this.$emit('changeShop', e)
    },
    // 打开选择类目
    async openCategoryDialog() {
      this.categoryShow = true
    },
    onCascaderPanelChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        if (i === len - 1) {
          this.categorySelectFullName += `${item.label}`
        } else {
          this.categorySelectFullName += `${item.label} > `
        }
      }
      this.categoryIsConfirm = true
    },
    onCascaderPanelExpandChange(e) {
      this.categorySelectFullName = ''
      for (let i = 0, len = e.length; i < len; i++) {
        const item = e[i]
        this.categorySelectFullName += `${item.label} > `
      }
      this.categoryIsConfirm = false
    },
    // 搜索类目
    async fetchCategoryByName() {
      try {
        if (!this.categorySearchText) return
        this.categorySearch = true
        const url =
          Baseurl + '/shopeeCategoryController/selectShopeeCategoryByName'
        const payload = { name: this.categorySearchText }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.categorySearchList = data.map((item) => {
            const label = `${item.originalCategoryName} - ${item.displayCategoryName}`
            const fullLabel = `${item.fullCategoryName} - ${item.fullCategoryNameCn}`
            return { label, fullLabel, ...item }
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 重置类目搜索
    resetCategorySearch() {
      this.categorySearch = false
      this.categorySearchText = ''
    },
    // 选择搜索类目
    confirmCategorySearch(item) {
      this.formData.categoryName = item.label
      this.formData.categoryId = item.categoryId
      this.formData.daysToShipRange = item.daysToShipRange

      this.fetchCategoryByAttr()
    },
    // 选择类目确认
    confirmCategory() {
      const res = this.$refs.CascaderPanelRef.getCheckedNodes()
      if (res.length) {
        this.formData.categoryName = res[0].value.label
        this.formData.categoryId = res[0].value.categoryId
        this.formData.daysToShipRange = res[0].value.daysToShipRange

        this.fetchCategoryByAttr()
      }
    },
    // 获取类目属性
    async fetchCategoryByAttr() {
      let loading
      try {
        loading = this.$loading({ text: '正在获取分类属性' })
        const url = Baseurl + '/shopeeCategoryController/getAttributeAndValues'
        const payload = { categoryId: this.formData.categoryId }
        // const payload = { categoryId: 100434 }
        const res = await ajaxPost(url, payload)
        loading.close()
        const { code, data } = res.data
        if (code === 200) {
          this.$emit('categoryAttr', data)
          this.categoryShow = false
        }
      } catch (error) {
        loading.close()
        console.log(error)
      }
    },
    // 生成sku编号
    async createSku() {
      const paramsData = {
        staffId: this.roleInfo.rid
      }
      const url = Baseurl + '/commonSettingController/getCommonSettingByStaffId'
      const res = await ajaxPost(url, paramsData)
      const { code, data } = res.data
      if (code === 200) {
        this.formData.sku = data.sku
        this.$emit('changeSku', this.formData.sku)
      } else {
        this.$message.error(data)
      }
    },
    setFormData(data) {
      this.formData = {
        name: data.name,
        shop: data.shop,
        categoryName: data.categoryName,
        categoryId: data.categoryId,
        sku: data.sku,
        desc: data.desc
      }
      this.fetchCategoryByAttr()
    },
    getFormData() {
      return JSON.parse(JSON.stringify(this.formData))
    },
    inputSkuchange(val) {
      if (val) {
        this.$emit('changeSku', val)
      }
    },

    //首字母大写
    capitalizeFirstLetter() {
      this.formData.name = this.formData.name
        .toLowerCase()
        .replace(/\b[a-z]/g, function (match) {
          return match.toUpperCase()
        })
    },
    //设置变体
    setBiantiList() {
      this.$emit('setBiantiList', this.bottomAttributeList)
    },

    //设置变体
    setBiantiList2(list) {
      this.$emit('setBiantiList2', this.bottomAttributeList, list)
    },
    //在线产品设置变体
    setBiantiList3() {
      this.$emit('setBiantiList3', this.bottomAttributeList)
    },
    //增加下面移除的变体
    addTopAttrList(attrList) {
      this.topAttributeList = this.topAttributeList.concat(attrList)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../shopee.less';

.search_box2 {
  padding: 15px 0px 15px 2px;
  width: calc(100%);
  background: rgb(238, 238, 238);
  margin-top: 10px;
}
.leimu_box2 {
  height: 400px;
  padding: 10px;
  overflow-y: auto;
  background: white;
  width: calc(100% - 20px);
  .leimu_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 7px 0;
    font-size: 14px;
    .leimu_item_desc {
      width: calc(100% - 20px);
      white-space: nowrap; /* 确保文本在一行内显示 */
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
    }
    .item_leimu_you {
      color: rgb(82, 190, 166);
      margin-top: 3px;
    }
  }
  .select_leimu {
    border: 1px solid rgb(82, 190, 166);
    box-sizing: content-box;
  }
  .leimu_item:hover {
    border: 1px solid rgb(82, 190, 166);
    color: rgb(82, 190, 166);
    box-sizing: content-box;
  }
}
.item_img {
  height: 16px;
  width: 16px;
  margin-left: 5px;
  cursor: pointer;
}
.el_tip_box {
  width: 360px;
  font-size: 16px;
  background: rgb(39, 39, 39);
  border-radius: 10px;
  padding: 8px;
  color: whitesmoke;
}
</style>
